import React from "react";
import classNames from "classnames";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";

import { Checkbox } from "@components/inputs/shared";
import PrematchOfferMenuStore from "@state/stores/offer/prematch/PrematchOfferMenuStore";
import { SportInteractionTypeEnum } from "@data-types/analytics-tracker/SportInteractionTypeEnum";
import { analyticsTracker } from "@utils/analytics";

export const SelectedSportCheckBox = observer(
	function SelectedSportCheckBox(props: {
		sport: PrematchOfferMenuStore["menu"];
		store: {
			toggleUpdateProcessing?: PrematchOfferMenuStore["toggleUpdateProcessing"];
		};
	}) {
		const t = useTranslation().t;

		if (props.sport == null) {
			return null;
		}

		const inputClassNames = classNames(
			"input--check__box input--check--sml__box",
			{
				"is-checked": props.sport.checkState === 1,
				indeterminate: props.sport.checkState === 2,
			}
		);

		return (
			<li className="nav--tertiary__item">
				<button
					className="nav--tertiary__link nav--tertiary__select-all"
					type="button"
					onClick={(e) => {
						e.preventDefault();
						e.stopPropagation();
						if (props.store.toggleUpdateProcessing != null) {
							props.store.toggleUpdateProcessing();
						}

						props.sport.onToggleCheck();
						if (props.sport.checkState === 1) {
							analyticsTracker.trackSportInteraction(
								window.location.pathname.includes("live")
									? SportInteractionTypeEnum.LiveSport
									: SportInteractionTypeEnum.PrematchSport,
								props.sport.node.abrv
							);
						}
						window.scrollTo(0, 0);
					}}
				>
					<span className="input--check input--check--sml">
						<Checkbox
							id={`sport-${props.sport.node.id}-select-all`}
							className={inputClassNames}
							name={props.sport.node.name}
							title={props.sport.node.name}
						/>
						<label
							htmlFor={`sport-${props.sport.node.id}-select-all`}
							className="input--check__label input--check--sml__label"
						>
							{t<string>("COMMON.SELECT_ALL")}
						</label>
					</span>
					<span className="nav--tertiary__counter counter counter--base">
						{props.sport.node.count}
					</span>
				</button>
			</li>
		);
	}
);
